/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import Cookies from "js-cookie";

import Configuration from "common/types/Configuration";
import { transformResponse } from "common/util";
import { ID_TOKEN } from "pages/LoginWeb/constants";

export const configurationApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: "",
        prepareHeaders: (headers, { getState }) => {
            const webToken = Cookies.get(ID_TOKEN);
            const { authToken: mobileToken, tenantId } = (getState() as any).configuration;

            if (webToken || mobileToken) {
                headers.set("x-via-driver-auth", webToken || mobileToken);
            }
            if (tenantId) {
                headers.set("x-via-tenant-id", tenantId);
            }
            return headers;
        },
    }),
    reducerPath: "configurationApi",
    endpoints: (builder) => ({
        getConfiguration: builder.query<Configuration, { url: string }>({
            query: ({ url }) => ({ url }),
            transformResponse,
        }),
    }),
});

export const { useLazyGetConfigurationQuery } = configurationApi;
